var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.pointClass},[_c('div',{staticClass:"point-icon"},[_c('span',{staticClass:"icon gift-point-icon img-responsive",attrs:{"size":this.size}})]),_c('span',{staticClass:"point-text"},[_vm._v(" "+_vm._s(this.formatPoint)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }